<div class="container auth-error mb-3">
  <p style="white-space: pre-line">{{ message }}</p>
</div>
